"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.parseBreakend = parseBreakend;exports.default = void 0;var _parse = _interopRequireDefault(require("./parse"));

function parseBreakend(breakendString) {
  var tokens = breakendString.split(/[[\]]/);
  if (tokens.length > 1) {
    var parsed = {};
    parsed.MateDirection = breakendString.includes('[') ? 'right' : 'left';
    for (var i = 0; i < tokens.length; i += 1) {
      var tok = tokens[i];
      if (tok) {
        if (tok.includes(':')) {
          // this is the remote location
          parsed.MatePosition = tok;
          parsed.Join = parsed.Replacement ? 'right' : 'left';
        } else {
          // this is the local alteration
          parsed.Replacement = tok;
        }
      }
    }
    return parsed;
  }
  return undefined;
}var _default =

_parse.default;exports.default = _default;